<template>
  <div class="browse-vehicles-background-component" id="search-hero-overflow-filter" role="region">
    <div class="search-hero-background">
      <div class="background-row" :style="{backgroundImage: bgPhoto}">
      </div>
      <div class="overlay-content">
        <video v-if="images.videoLink.length > 0" autoplay="true" class="hidden-xs" id="homepage-background-video" loop="true" muted="true">
          <source class="ajax-video" :src="images.videoLink" type="video/mp4">
        </video>
        <div class="container">
          <div class="row">
            <div class="col-xs-12">
              <div class="browse-hero-content text-center">
                <h3>Customizable Message</h3>
                <h1>Hometown Auto Dealer</h1>
                <a class="btn search-hero-btn" href="#">Shop Now</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="browse-overflow">
      <div class="browse-vehicles">
        <div class="container">
          <div class="row browse-row vehicle-browse-row">
            <div class="col-xs-12">
              <div class="vehicle-browse-ajax">
                <form action="/vehicles" class="vehicle-search-form" method="get">
                  <input class="inventory-type set-on-load" name="new" type="hidden" value="true">
                  <div class="form-group">
                    <label class="visuallyhidden" for="dropdown-vehicle-type">Select vehicle type:</label>
                    <select aria-labelledby="dropdown-search-title" class="form-control vehicle-search search-inv-type" id="dropdown-vehicle-type" name="type">
                      <option data="true" value="new">New</option>
                      <option data="false" value="used">Used</option>
                    </select>
                    <i class="material-icons">keyboard_arrow_down</i>
                  </div>
                  <div class="form-group">
                    <label class="visuallyhidden" for="dropdown-vehicle-year">Select vehicle year:</label>
                    <select aria-labelledby="dropdown-search-title" class="form-control vehicle-search vehicle-search-year" id="dropdown-vehicle-year" name="year">
                      <option value="default">Year</option>
                    </select>
                    <i class="material-icons">keyboard_arrow_down</i>
                  </div>
                  <div class="form-group">
                    <label class="visuallyhidden" for="dropdown-vehicle-make">Select vehicle make:</label>
                    <select aria-labelledby="dropdown-search-title" class="form-control vehicle-search vehicle-search-make" id="dropdown-vehicle-make" name="make">
                      <option value="make">{{ brandName }}</option>
                    </select>
                    <i class="material-icons">keyboard_arrow_down</i>
                  </div>
                  <div class="form-group">
                    <label class="visuallyhidden" for="dropdown-vehicle-model">Select vehicle model:</label>
                    <select aria-labelledby="dropdown-search-title" class="form-control vehicle-search vehicle-search-model" id="dropdown-vehicle-model" name="model">
                      <option value="default">Model</option>
                    </select>
                    <i class="material-icons">keyboard_arrow_down</i>
                  </div>
                  <div class="form-group" id="search-submit">
                    <input aria-label="Click here to submit" class="btn search-form-btn vehicle-search-submit" value="Search">
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['images'],
  data() {
    return {
      brand: this.$store.state.chosenBrand
    }
  },
  computed: {
    brandName () {
      if (this.brand === 'none') {
        return 'Brand';
      } else if (this.brand === 'infiniti' || this.brand === 'cjdr') {
        return this.brand.toUpperCase();
      } else {
        return this.brand.charAt(0).toUpperCase() + this.brand.slice(1);
      }
    },
    bgPhoto () {
      if (this.brand !== 'honda' && this.brand !== 'cjdr') {
        return 'url(' + this.images.lifestyleImages.defaultImage + ')';
      } else if (this.brand === 'cjdr') {
        return 'url(' + this.images.lifestyleImages.truckImage + ')';
      } else {
        return 'url(' + this.images.lifestyleImages.suvImage + ')';
      }
    }
  }
};
</script>

<style
  scoped
  src="../../static/bootstrap-3.3.7-dist/css/bootstrap.min.css"
></style>

<style scoped>
.visuallyhidden {
  display: none;
}
#search-hero-overflow-filter {
  text-transform: uppercase;
}
#search-hero-overflow-filter .container {
  padding: 0 15px;
}
#search-hero-overflow-filter .search-hero-background {
  position: relative;
  height: 0;
  padding-bottom: 28.125%;
  overflow: hidden;
}
#search-hero-overflow-filter .background-row {
  position: absolute;
  z-index: -1;
  top: 0px;
  left: 0px;
  bottom: 0px;
  right: 0px;
  overflow: hidden;
  background-size: cover;
  background-color: #222;
  background-repeat: no-repeat;
  background-position: 50% 50%;
}
#search-hero-overflow-filter .browse-hero-content h1, 
#search-hero-overflow-filter .browse-hero-content h3 {
  color: #fff;
  text-transform: uppercase;
  font-weight: 500;
  letter-spacing: 2px;
  text-shadow: 0 2px 4px rgb(0 0 0 / 50%);
}
#search-hero-overflow-filter .browse-hero-content h1 {
  font-size: 2.5rem;
  margin-top: 12px;
  font-family: var(--heading-text);
}
#search-hero-overflow-filter .browse-hero-content h3 {
  font-size: 1.5rem;
  margin-bottom: 12px;
  font-family: var(--subheading-text);
}
#search-hero-overflow-filter .browse-hero-content .search-hero-btn {
  color: var(----primary-dark);
  background: #fff;
  border-color: #fff;
  padding: 10px 30px;
  margin-top: 30px;
  text-transform: uppercase;
  letter-spacing: 2px !important;
  font-size: 13px;
  border-radius: 3px;
  border-width: 2px;
  border-style: solid;
  display: inline-block;
  text-decoration: none !important;
  -webkit-transition: .3s all ease;
  -o-transition: .3s all ease;
  transition: .3s all ease;
}
#search-hero-overflow-filter .browse-hero-content .search-hero-btn:hover {
  color: #fff;
  background: transparent;
}
#search-hero-overflow-filter .overlay-content {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  width: 100%;
  text-align: center;
  padding-top: 40px;
  padding-bottom: 0;
  height: 100%;
  overflow: hidden;
  background: linear-gradient(rgb(29 29 29 / 47%), rgb(24 24 25 / 30%));
}
video#homepage-background-video {
  position: absolute;
  bottom: -30%;
  left: 0;
  right: 0;
  min-height: 100%;
  width: 100%;
  height: auto;
  z-index: -1;
  background-size: cover;
}
#search-hero-overflow-filter .browse-overflow {
  margin: -35px auto 0px !important;
  z-index: 8;
  padding-bottom: 30px;
  overflow: visible;
}
#search-hero-overflow-filter .vehicle-browse-row {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
  overflow: hidden;
  background-size: cover;
}
#search-hero-overflow-filter .vehicle-browse-ajax {
  width: 100%;
  max-width: 1024px;
  margin: auto auto 20px;
  padding: 15px;
  background: #fff;
  border-radius: 3px;
  box-shadow: 0px 0px 16px rgb(16 16 16 / 26%);
}
#search-hero-overflow-filter .vehicle-browse-ajax .form-group {
  flex: 0 0 20%;
  position: relative;
  margin-bottom: 0px;
}
#search-hero-overflow-filter .vehicle-browse-ajax .form-group:not(#search-submit) {
  background-color: #fff;
  line-height: 32px;
}
#search-hero-overflow-filter .vehicle-browse-ajax .form-group i {
  position: absolute;
  line-height: 40px;
  right: 12px;
  top: 0;
}
#search-hero-overflow-filter .vehicle-browse-ajax .form-control {
  display: block;
  width: 100%;
  height: 100%;
  position: relative;
  appearance: none;
  -moz-appearance: none;
  -webkit-appearance: none;
  z-index: 1;
  background-color: transparent;
  border: none;
  border-radius: 0px;
  box-shadow: none;
  padding: 6px 12px 6px 0px;
  text-transform: uppercase;
  text-align: center;
  letter-spacing: 2px;
  font-size: 13px;
}
#search-hero-overflow-filter .vehicle-browse-ajax .search-form-btn.vehicle-search-submit {
  background-color: var(--primary-color);
  color: #fff;
  border: none;
  border-radius: 3px;
  text-transform: uppercase;
  letter-spacing: 2px;
  padding: 12px 0px;
  font-size: 13px;
  width: 100%;
  max-width: 100%;
  -webkit-transition: all 0.3s ease;
  -moz-transition: all 0.3s ease;
  -o-transition: all 0.3s ease;
  transition: all .3s ease;
}
#search-hero-overflow-filter .vehicle-browse-ajax .search-form-btn.vehicle-search-submit:hover {
  opacity: .7;
}

@media (max-width: 1199px) {
  #search-hero-overflow-filter .browse-hero-content h3 {
    margin-top: 0px;
  }
}

@media (max-width: 991px) {
  #search-hero-overflow-filter .vehicle-browse-ajax .search-form-btn.vehicle-search-submit {
    padding: 10px 0px;
  }
  #search-hero-overflow-filter .vehicle-browse-ajax .form-group i {
    line-height: 37px;
  }
  #search-hero-overflow-filter .browse-hero-content h1 {
    font-size: 2.125rem;
    margin: 6px auto 0;
  }
  #search-hero-overflow-filter .browse-hero-content h3 {
    margin: 0px auto 6px;
    letter-spacing: 1.08px;
    font-size: 1.125rem;
  }
  #search-hero-overflow-filter .browse-hero-content .search-hero-btn {
    margin-top: 16px;
  }
}

@media (min-width: 768px) {
  #search-hero-overflow-filter .browse-row {
    padding: 0 15px;
  }
  #search-hero-overflow-filter .search-row {
    padding: 0 30px;
  }
  #search-hero-overflow-filter .vehicle-search-form {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    justify-content: space-between;
  }
  #search-hero-overflow-filter .vehicle-browse-ajax .form-group {
    flex-basis: 20%;
    max-width: 20%;
  }
  #search-hero-overflow-filter .form-group:nth-of-type(1), 
  #search-hero-overflow-filter .form-group:nth-of-type(2), 
  #search-hero-overflow-filter .form-group:nth-of-type(3) {
    margin-right: 0px !important;
    border-right: 1px solid #999999;
  }
  #search-hero-overflow-filter .form-group:nth-of-type(4) {
    padding-right: 12px;
  }
  #search-hero-overflow-filter .form-group:nth-of-type(4) i {
    right: 24px;
  }
}

@media (max-width: 767px) {
  #search-hero-overflow-filter .overlay-content {
    padding: 60px 45px;
    position: relative;
    min-height: 460px;
  }
  #search-hero-overflow-filter .search-hero-background {
    padding-bottom: 0;
    height: auto;
  }
  #search-hero-overflow-filter .browse-hero-content .search-hero-btn {
    margin-top: 24px;
  }
  #search-hero-overflow-filter .browse-overflow {
    margin: -138px auto 0px !important;
  }
  #search-hero-overflow-filter .col-xs-12 .vehicle-browse-ajax {
    max-width: 360px !important;
  }
  #search-hero-overflow-filter .form-group {
    max-width: 300px;
    margin: auto;
  }
  #search-hero-overflow-filter .vehicle-browse-ajax .form-group:not(:last-child) {
    padding-top: 6px;
    padding-bottom: 6px;
    margin-bottom: 6px;
  }
  #search-hero-overflow-filter .form-group:nth-of-type(1), 
  #search-hero-overflow-filter .form-group:nth-of-type(2), 
  #search-hero-overflow-filter .form-group:nth-of-type(3) {
    margin-bottom: 6px !important;
    border-bottom: 1px solid #999999;
  }
  #search-hero-overflow-filter .vehicle-browse-ajax .search-form-btn.vehicle-search-submit {
    padding: 15px 0px;
  }
}

@media (max-width: 575px) {
  #search-hero-overflow-filter .overlay-content {
    padding: 30px 15px;
    min-height: 400px;
  }
  #search-hero-overflow-filter .browse-hero-content h1 {
    font-size: 2rem;
    margin: 12px auto 0;
  }
}
</style>